import { Switch } from 'antd'
import React, { useEffect } from 'react'

interface FormData {
  instantBooking: boolean
  refundableBooking: boolean
  changeDateAvailable: boolean
  [key: string]: any
}

interface StepProps {
  formData: FormData
  updateFormData: (data: Partial<FormData>) => void
  onPrevious: () => void
  onSubmit: () => void
  isSubmitting: boolean
  onStepProgress: (progress: number) => void
}

const Step5: React.FC<StepProps> = ({
  formData,
  updateFormData,
  onPrevious,
  onSubmit,
  isSubmitting,
  onStepProgress,
}) => {
  // Report 100% progress when the step loads
  useEffect(() => {
    onStepProgress(100)
  }, [onStepProgress])

  const handleToggleChange = (
    field: 'instantBooking' | 'refundableBooking' | 'changeDateAvailable',
    checked: boolean,
  ) => {
    updateFormData({ [field]: checked })
  }

  return (
    <div
      style={{
        backgroundColor: '#fff',
        padding: '16px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '500px',
        margin: '0 auto',
        boxSizing: 'border-box',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      <div style={{ marginBottom: '24px' }}>
        <div
          style={{
            fontSize: '14px',
            color: '#667085',
            marginBottom: '8px',
            fontFamily: 'Poppins, sans-serif',
          }}
        >
          STEP 5 OF 5
        </div>
        <h2
          style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#212427',
            margin: '0',
            fontFamily: 'Poppins, sans-serif',
          }}
        >
          Add booking options
        </h2>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 0',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <span
            style={{
              fontSize: '16px',
              color: '#212427',
              fontWeight: '500',
              margin: '0',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Instant booking confirmation
          </span>
        </div>
        <Switch
          checked={formData.instantBooking || false}
          onChange={(checked) => handleToggleChange('instantBooking', checked)}
          disabled={isSubmitting}
        />
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 0',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <span
            style={{
              fontSize: '16px',
              color: '#212427',
              fontWeight: '500',
              margin: '0',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Refundable booking
          </span>
        </div>
        <Switch
          checked={formData.refundableBooking || false}
          onChange={(checked) => handleToggleChange('refundableBooking', checked)}
          disabled={isSubmitting}
        />
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 0',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <span
            style={{
              fontSize: '16px',
              color: '#212427',
              fontWeight: '500',
              margin: '0',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Change date available
          </span>
        </div>
        <Switch
          checked={formData.changeDateAvailable || false}
          onChange={(checked) => handleToggleChange('changeDateAvailable', checked)}
          disabled={isSubmitting}
        />
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '32px',
        }}
      >
        <button
          onClick={onPrevious}
          style={{
            padding: '12px 24px',
            borderRadius: '24px',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '16px',
            fontFamily: 'Poppins, sans-serif',
            height: '48px',
            border: '1px solid #D6DAE0',
            backgroundColor: 'transparent',
            color: '#667085',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
          disabled={isSubmitting}
        >
          ← Back
        </button>
        <button
          onClick={onSubmit}
          style={{
            padding: '12px 24px',
            borderRadius: '24px',
            cursor: isSubmitting ? 'not-allowed' : 'pointer',
            fontWeight: '500',
            fontSize: '16px',
            fontFamily: 'Poppins, sans-serif',
            height: '48px',
            border: 'none',
            backgroundColor: isSubmitting ? '#D6DAE0' : '#0048B3',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span
                style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid #ffffff',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              ></span>
              Submitting...
            </>
          ) : (
            'Submit'
          )}
        </button>
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  )
}

export default Step5
